import type { HandoffTarget } from '@sentinel/shared';

/** On `accounts.`: where the person is going once signed in (the target app, its challenge, the
 *  organization asked for). Kept in the tab, so it survives the Google round trip and the second
 *  factor steps. */
export interface PendingHandoff {
  target: HandoffTarget;
  challenge: string;
  organizationId?: string;
  grantId?: string;
}

const KEY = 'sentinel.handoff.pending';

export function savePendingHandoff(pending: PendingHandoff): void {
  sessionStorage.setItem(KEY, JSON.stringify(pending));
}

export function hasPendingHandoff(): boolean {
  return sessionStorage.getItem(KEY) !== null;
}

export function takePendingHandoff(): PendingHandoff | null {
  const raw = sessionStorage.getItem(KEY);
  sessionStorage.removeItem(KEY);
  if (raw === null) return null;
  try {
    return JSON.parse(raw) as PendingHandoff;
  } catch {
    return null;
  }
}

/** Reads `?to=&challenge=&org=` of the sign-in page of `accounts.`. */
export function pendingFromSearch(search: Record<string, unknown>): PendingHandoff | null {
  const { to, challenge, org, grant } = search;
  if ((to !== 'console' && to !== 'control') || typeof challenge !== 'string') return null;
  return {
    target: to,
    challenge,
    ...(typeof org === 'string' ? { organizationId: org } : {}),
    ...(typeof grant === 'string' ? { grantId: grant } : {}),
  };
}
